// extracted by mini-css-extract-plugin
module.exports = {"list":"tGt-a3QGlvvA-gsZQi73W","item":"IpKOqV2kyBZmgH74Pu6uK"};